import RowsCache from "../jslibs/RowsCache"
import { type INut } from "../shared/IFood";
import FoodApi from "./FoodApi";

export default class Nuts extends RowsCache<INut> {
    private static _i:Nuts
    static get i(){
        if (!this._i) this._i = new Nuts("nuts", 3600)
        return this._i
    }
    fetch(): Promise<INut[]> {
        return FoodApi.i.nutrients()
    }
    key(row: INut): string {
        return row._id.toString()
    }
}
